"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asisDevelopmentCCSubappLoader = void 0;
const subappDevelopmentBaseLoader_1 = require("../subappDevelopmentBaseLoader");
/**
 * Wraps the app in the providers and mounts it directly into the DOM
 */
const asisDevelopmentCCSubappLoader = async (params) => {
    // if (isDRPicasoRoute()) {
    //   await DRPicasoAuthenticator.loginAgent();
    // } else if (!isDevelopmentLogicCCRoute()) {
    //   if (!CCDevSession.isValid() && !DRPicasoSession.isValid()) {
    //     await USDAuthenticator.login();
    //   }
    // }
    await (0, subappDevelopmentBaseLoader_1.developmentSubappBaseFeatureLoader)(params);
    (0, subappDevelopmentBaseLoader_1.developmentSubappBaseRender)(params);
};
exports.asisDevelopmentCCSubappLoader = asisDevelopmentCCSubappLoader;
//# sourceMappingURL=index.js.map